/** Topics a client can subscribe to on the live-updates channel. Must match LIVE_UPDATE_TOPIC_GROUPS. */
export type LiveUpdateTopic = "signature_state"

export const SIGNATURE_STATE_TOPIC: LiveUpdateTopic = "signature_state"

/** Every live-update message shares this shape and is discriminated by `topic` and `event`. */
export type LiveUpdateEnvelope<TPayload = unknown> = {
    topic: LiveUpdateTopic
    event: string
    payload: TPayload
}

export const LIVE_UPDATES_SUBSCRIBE = "LIVE_UPDATES_SUBSCRIBE"

export type iLiveUpdatesSubscribe = {
    type: typeof LIVE_UPDATES_SUBSCRIBE
    topics: LiveUpdateTopic[]
}

export const LIVE_UPDATES_UNSUBSCRIBE = "LIVE_UPDATES_UNSUBSCRIBE"

export type iLiveUpdatesUnsubscribe = {
    type: typeof LIVE_UPDATES_UNSUBSCRIBE
    topics: LiveUpdateTopic[]
}
